/**
 * Работа с Cookies
 */
import Cookies from 'js-cookie';

/**
 * Получаем куки по имени. Если кука не создана или null,
 * то возвращаем false. В противном случае, возвращаем куку.
 * @param name
 * @returns {boolean|*}
 */
window.getCookie = name => {
    if(typeof Cookies.get(name) == 'undefined' || Cookies.get(name) == null) {
        return false;
    }

    return Cookies.get(name);
}

/**
 * Устанавливаем куку.
 * @param name
 * @param value
 * @param expiresDays
 */
window.setCookie = (name, value, expiresDays = 365) => {
    Cookies.set(name, value, {expires: expiresDays});
}

/**
 * Удаляем куку.
 * @param name
 */
window.removeCookie = name => {
    Cookies.remove(name);
}
